export const AdminOrderForm = {
  model: 'Order',
  format: [
    {
      widths: 'equal',
      fields: {
        project_name: {
          required: true,
          required: true,
          type: 'text',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        buyer: {
          required: true,
          type: 'search',
          url: '/main/buyers/',
          label: 'Buyer',
          title_fields: ['business.name'],
          filter_field: 'business__name__icontains',
          params: {
            tenant_aware: false,
            business__archived: false,
          },
          description_fields: [
            'business.contact_first_name',
            'business.contact_last_name',
          ],
        },
        delivery_address: {
          required: false,
          type: 'dropdown search',
          url: '/main/locations/',
          // This says: require all 'related_params' in order to display values
          require_params: true,
          // this says: pass in the current buyer field (above field) as "buyer_id" into the dropdown search
          related_params: {
            buyer: 'buyer_id',
          },
          params: {
            tenant_aware: false,
          },
          title_fields: ['name'],
          description_fields: ['address_1', 'city', 'state', 'zip_code'],
          filter_field: 'name__icontains',
          allow_add: true,
          // this says: pass in the current supplier field (above field) as "supplier_id" into the add form values
          allow_add_related_params: {
            buyer: 'buyer_id',
          },
          model: 'Location',
          model_form: 'LocationForm',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        order_number: {
          label: 'Deal Number',
          required: false,
          type: 'text',
        },
        order_date: {
          label: 'Deal Date',
          type: 'date',
          required: true,
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        scrapgo_status: {
          required: true,
          type: 'dropdown',
          label: 'Status',
        },
        salespersons: {
          label: 'Salespeople',
          type: 'multiple dropdown model',
          url: '/main/admin-users/?light_serializer=true',
          option_text_fields: ['full_name', 'email'],
        },
      },
    },
    // {
    //   widths: 'equal',
    //   fields: {
    //     po_number: {
    //       required: false,
    //       type: 'text',
    //     },
    //     so_number: {
    //       required: false,
    //       type: 'text',
    //     },
    //   },
    // },
    {
      widths: 'equal',
      fields: {
        project_ship_start_date: {
          required: false,
          label: 'Expected Start Date',
          type: 'date',
        },
        project_ship_end_date: {
          required: false,
          label: 'Expected End Date',
          type: 'date',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        owner: {
          required: false,
          label: 'Owner',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
        lender: {
          required: false,
          label: 'Lender',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        general_contractor: {
          required: false,
          label: 'General Contractor',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
        subcontractor: {
          required: false,
          label: 'Subcontractor',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        lien_agent: {
          required: false,
          label: 'Lien Agent',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
        bonding_company: {
          required: false,
          label: 'Bonding Company',
          type: 'search',
          url: '/main/admin-businesses/?light_serializer=true',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          params: {
            tenant_aware: false,
            archived: false,
          },
          description_fields: ['contact_first_name', 'contact_last_name'],
        },
      },
    },
  ],
}
